import React from 'react';

export const Mentor = ({ name, des, image }) => {
    return (
        <div className='flex gap-10'>
            {/* Image */}
            <div className='bg-blue-500 rounded-full h-36 w-36 max-sm:h-20 max-sm:w-20 overflow-hidden'>
                {image && (
                    <img
                        src={image}
                        alt={name}
                        className='h-full w-full object-cover'
                    />
                )}
            </div>

            <div className='flex flex-col w-80 max-sm:w-60'>
                {/* Title */}
                <h3 className='font-semibold text-2xl mt-2'>
                    {name}
                </h3>

                {/* Description */}
                <p className='mt-3 text-sm'>
                    {des}
                </p>
            </div>
        </div>
    );
};
